export const has = (obj, key) => {
  let args = key.split('.')
  for (let i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false
    }
    obj = obj[args[i]]
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/index.js